/**
 * Strips markdown syntax from text while preserving line breaks.
 */
export const stripMarkdown = (text: string): string => {
    if (!text) return "";

    return text
        // 1. Remove HTML comments
        .replace(/<!--[\s\S]*?-->/g, '')
        // 2. Remove code blocks but keep content
        .replace(/```[\s\S]*?```/g, (match) => {
            const lines = match.split('\n');
            return lines.slice(1, -1).join('\n');
        })
        // 3. Remove inline code backticks
        .replace(/`([^`]+)`/g, '$1')
        // 4. Remove bold/italic symbols
        .replace(/(\*\*|__)(.*?)\1/g, "$2")
        .replace(/(\*|_)(.*?)\1/g, "$2")
        // 5. Remove headers symbols
        .replace(/^#+\s+/gm, "")
        // 6. Remove links [text](url) -> text (Optimized matching to avoid catastrophic backtracking)
        .replace(/\[([^\]]{1,100})\]\([^)]{1,200}\)/g, "$1")
        // 7. Remove blockquotes symbols
        .replace(/^[ \t]*>[ \t]+/gm, "")
        // 8. Remove strikethrough symbols
        .replace(/~~(.*?)~~/g, "$1")
        .trim();
};
